/* eslint-disable */
import requestRaw from '@/utils/requestRaw'
import { APICore } from '@/utils/servicesApi'
const qs = require('qs')
export function deleteTagSelected(data) {
    return requestRaw({
        url: APICore() + '/crm/tag/delete-selected',
        method: 'POST',
        data: data // untuk array data post
    })
}

export function countContactByTagId(tagId) {
    return requestRaw({
        url: APICore() + '/crm/tag/count-contact-bytagid?id=' + tagId,
        method: 'GET',
    })
}
export function unassignFromOneTag(param) {
    return requestRaw({
        url: APICore() + '/crm/tag/unassign-tag',
        method: 'POST',
        data: param // untuk array data post
    })
}
export function getTagDetailByContactId(param) {
    return requestRaw({
        url: APICore() + '/crm/tag/get-tag-detail-by-contactid',
        method: 'POST',
        data: param // untuk array data post
    })
}
export function getTagDetailByTagsId(param) {
    return requestRaw({
        url: APICore() + '/crm/tag/get-tag-detail-by-tagsid',
        method: 'POST',
        data: param // untuk array data post
    })
}
export function assignContactToTag(param) {
    return requestRaw({
        url: APICore() + '/crm/tag/add-contact-to-tag',
        method: 'POST',
        data: param // untuk array data post
    })
}
export function detailTag(id) {
    return requestRaw({
        url: APICore() + '/crm/tag/detail?id=' + id,
        method: 'GET',
    })
}
export function createTag(data) {
    return requestRaw({
        url: APICore() + '/crm/tag/create',
        method: 'POST',
        data: data // untuk array data post
    })
}
export function updateTag(data) {
    return requestRaw({
        url: APICore() + '/crm/tag/update?id=' + data.id,
        method: 'POST',
        data: data // untuk array data post
    })
}
export function listTags(data) {
    return requestRaw({
        url: APICore() + '/crm/tag/get-tag-list',
        method: 'POST',
        data: data // untuk array data post
    })
}


export function listTagsBC(data) {
    return requestRaw({
        url: APICore() + '/crm/tag/get-tag-list-bc',
        method: 'POST',
        data: data // untuk array data post
    })
}

export function deleteTag(id) {
    return requestRaw({
        url: APICore() + '/crm/tag/delete?id=' + id,
        method: 'GET',
    })
}


// WEBPACK FOOTER //
// ./src/api/crm.js